import crc1 from './crc1';
import crc8 from './crc8';
import crc81wire from './crc81wire';
import crc16 from './crc16';
import crc16ccitt from './crc16ccitt';
import crc16modbus from './crc16modbus';
import crc16xmodem from './crc16xmodem';
import crc16kermit from './crc16kermit';
import crc24 from './crc24';
import crc32 from './crc32';
import crcjam from './crcjam';

export { crc1 };
export { crc8 };
export { crc81wire };
export { crc16 };
export { crc16ccitt };
export { crc16modbus };
export { crc16xmodem };
export { crc16kermit };
export { crc24 };
export { crc32 };
export { crcjam };

export default {
  crc1,
  crc8,
  crc81wire,
  crc16,
  crc16ccitt,
  crc16modbus,
  crc16xmodem,
  crc16kermit,
  crc24,
  crc32,
  crcjam,
};
